/* BOHEMIA OFFER CODE. The one owner of storefront discount codes. Loaded on every page.
 *
 * [HARD RULE, Jorge 18 Sep 2026] Codes live ON THE CART and nowhere else. Full record:
 * bohemia-ops/claude-project/"DECISION - Discount codes live on the cart, never in discount links, 18 Sep 2026.md".
 *
 * - A landing page declares its code with data-bs-offer-code="GOOGLE20" on any element. It writes
 *   no discount logic of its own.
 * - The code is written with Shopify's Cart AJAX API, POST /cart/update.js {discount}, which
 *   replaces the whole list, so the codes already on the cart are always sent back with it.
 * - NEVER /discount/CODE: that legacy link also saves the code in the browser, and when the cart is
 *   replaced the drawer shows full price while checkout still discounts (live V27, 18 Sep 2026).
 * - ONLY ADD, never remove. Measured: once checkout has applied a code for a cart it keeps it even
 *   after the API drops it from that cart, so removing here would make cart and checkout disagree.
 * - A code on an empty cart is kept and reads applicable:false until an eligible item is added.
 *   "Applied" is only ever reported when /cart.js says applicable:true.
 * - MIGRATION: a visitor still carrying the old discount_code cookie (set by the legacy link) gets
 *   that code moved onto the cart, then the cookie is deleted, so cart and checkout agree again.
 *
 * Emits document event 'bohemia:offer-state' with { cart, applied: {CODE: true|false} } after every
 * read, so a page can paint its own "code applied" note.
 */
(function () {
  if (window.BohemiaOffer) return;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var MAX_WRITES_PER_CART = 3;
  var writes = {};
  var busy = null;

  var up = function (s) { return String(s || '').trim().toUpperCase(); };

  var legacyCookie = function () {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    if (!m) return [];
    try { return decodeURIComponent(m[1]).split(',').map(up).filter(Boolean); } catch (e) { return []; }
  };
  var deleteLegacyCookie = function () {
    var past = 'Thu, 01 Jan 1970 00:00:00 GMT';
    var host = location.hostname;
    var parts = host.split('.');
    var domains = ['', host, '.' + parts.slice(-2).join('.')];
    domains.forEach(function (d) {
      document.cookie = 'discount_code=; expires=' + past + '; path=/' + (d ? '; domain=' + d : '');
    });
  };

  var declared = function () {
    var out = [];
    document.querySelectorAll('[data-bs-offer-code]').forEach(function (el) {
      var c = up(el.getAttribute('data-bs-offer-code'));
      if (c && out.indexOf(c) < 0) out.push(c);
    });
    return out;
  };

  var getCart = function () {
    return fetch(ROOT + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; });
  };

  var codesOn = function (cart) {
    return ((cart && cart.discount_codes) || []).map(function (d) { return up(d.code); }).filter(Boolean);
  };

  var refreshDrawer = function () {
    var api = window.kachingCartApi;
    if (!api || typeof api.refreshCart !== 'function') return;
    try { api.refreshCart(); } catch (e) {}
    window.setTimeout(function () { try { api.refreshCart(); } catch (e2) {} }, 1500);
  };

  var announce = function (cart) {
    if (!cart) return;
    var applied = {};
    (cart.discount_codes || []).forEach(function (d) { applied[up(d.code)] = d.applicable === true; });
    document.dispatchEvent(new CustomEvent('bohemia:offer-state', { detail: { cart: cart, applied: applied } }));
  };

  /* Make sure every wanted code is on the cart. Idempotent; at most MAX_WRITES_PER_CART writes per
     cart token, so a code the cart keeps rejecting can never loop. */
  var ensure = function () {
    if (busy) return busy;
    var fromCookie = legacyCookie();
    var wanted = declared().concat(fromCookie).filter(function (c, i, a) { return a.indexOf(c) === i; });
    /* Pages with no offer and no legacy cookie cost nothing: no request at all. */
    if (!wanted.length) return Promise.resolve(null);
    busy = getCart().then(function (cart) {
      if (!cart) return null;
      var have = codesOn(cart);
      var missing = wanted.filter(function (c) { return have.indexOf(c) < 0; });
      if (!missing.length) {
        if (fromCookie.length) deleteLegacyCookie();
        announce(cart);
        return cart;
      }
      var token = cart.token || 'none';
      writes[token] = (writes[token] || 0) + 1;
      if (writes[token] > MAX_WRITES_PER_CART) { announce(cart); return cart; }
      return fetch(ROOT + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin', cache: 'no-store',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: have.concat(missing).join(',') })
      }).then(function (r) { return r.ok ? r.json() : null; }).then(function (updated) {
        if (updated) {
          var now = codesOn(updated);
          if (fromCookie.length && fromCookie.every(function (c) { return now.indexOf(c) >= 0; })) deleteLegacyCookie();
          refreshDrawer();
          announce(updated);
        }
        return updated;
      });
    }).catch(function () { return null; }).then(function (res) { busy = null; return res; });
    return busy;
  };

  window.BohemiaOffer = { ensure: ensure, declared: declared, getCart: getCart };

  /* When the cart changes, re-check: another app's cart update can drop a code (measured on promo2026). */
  var later = function () { [150, 1500, 4000].forEach(function (ms) { window.setTimeout(ensure, ms); }); };
  ['bohemia:cart-updated', 'cart:change', 'variant:add', 'kaching-cart:item-added'].forEach(function (n) {
    document.addEventListener(n, later);
  });
  window.addEventListener('pageshow', function () { ensure(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { ensure(); });
  else ensure();
})();
